import { handleActions } from "redux-actions";
import {
  PURCHASE_REQUEST_BATCH,
  PURCHASE_REQUEST_BATCH_SUCCESS,
  PURCHASE_REQUEST_BATCH_FAILURE,
  PURCHASE_REQUEST_BATCH_INIT
} from "../actionCreators";

const initialState = {
  isRequesting: false,
  isRequested: false,
  batchNum: null,
  errorReason: null
};

const bookMultiRequestReducer = handleActions(
  {
    [PURCHASE_REQUEST_BATCH]: state => ({
      ...state,
      isRequesting: true,
      isRequested: false,
      batchNum: null,
      errorReason: null
    }),
    [PURCHASE_REQUEST_BATCH_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      isRequesting: false,
      isRequested: true,
      batchNum: (data && data.batchNum) || null,
      errorReason: null
    }),
    [PURCHASE_REQUEST_BATCH_FAILURE]: (state, { payload: error }) => ({
      ...state,
      isRequesting: false,
      isRequested: false,
      batchNum: null,
      errorReason: error
    }),
    [PURCHASE_REQUEST_BATCH_INIT]: state => ({
      ...state,
      isRequesting: false,
      isRequested: false,
      batchNum: null,
      errorReason: null
    })
  },
  initialState
);

export default bookMultiRequestReducer;
